import React, { useState, useEffect, useCallback } from 'react';
import { List, Spin, Row, Col } from 'antd';

import BaseAlert from 'components/wrappers/BaseAlert';
import BasePageCard from 'components/wrappers/BasePageCard';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import { getHomepageStatistics } from 'redux/reducers/dashboardSlice';
import { HomepageStatisticsResponse } from 'api/adminApiClient';
import { useAppDispatch } from 'hooks/useAppDispatch';

import styles from './HomepageAnalytics.module.less';

export default function HomepageAnalytics() {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [analytics, setAnalytics] = useState<HomepageStatisticsResponse>();

  const loadAnalytics = useCallback(async () => {
    setIsLoading(true);
    const result = await dispatch(getHomepageStatistics());
    setIsLoading(false);

    if (getHomepageStatistics.fulfilled.match(result)) {
      setAnalytics(result.payload);
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  }, [dispatch]);

  useEffect(() => {
    loadAnalytics();
  }, [loadAnalytics]);

  if (isLoading) return <Spin />;

  if (!analytics) return null;

  const listData = [
    {
      label: 'Staffing Firm/Independent Recruiter',
      value: analytics.independentRecruiterCount,
    },
    {
      label: 'Gig Worker/Independent Consultant',
      value: analytics.independentConsultantCount,
    },
    {
      label: 'Corporate Talent Acquisition Entity',
      value: analytics.corporateTAEntityCount,
    },
  ];

  return (
    <BasePageCard
      className="full-header stretch-card"
      title="Homepage Analytics"
      icons={<span className="icon icon-analytics" />}
    >
      <List
        dataSource={listData}
        renderItem={({ label, value }) => (
          <List.Item>
            <Row gutter={[2, 2]}>
              <Col xs={24} lg={14}>
                <b>{label}</b>
              </Col>

              <Col xs={24} lg={10}>
                <div className={styles.value}>{value}</div>
              </Col>
            </Row>
          </List.Item>
        )}
      />
    </BasePageCard>
  );
}
